import { encodedCustomerAuthorize } from "../constants/CARD_PAYMENT";
import HttpErrorResponseModel from "../models/HttpErrorResponseModel";
import * as HttpUtility from "./HttpUtility";

function _restModelCreator(Model, response) {
    if (response instanceof HttpErrorResponseModel) {
        return response;
    }

    return !Array.isArray(response.data) ? new Model(response.data) : response.data.map((json) => new Model(json));
}

async function _sendUnzerCustomerRequestWithBearer(requestFunction, endpoint, params = {}, secured) {
    let response = await requestFunction(endpoint, secured ? {Authorization: encodedCustomerAuthorize(), "Access-Control-Allow-Origin": "true"} : {}, params);
    return response;
}

export async function postCustomerToUnzer(Model, endpoint, data = {}, secured = true) {
    const response = await _sendUnzerCustomerRequestWithBearer(HttpUtility.post, endpoint, data, secured);

    return _restModelCreator(Model, response);
}